import { useEffect } from 'react';
import { useUIStore } from '@/stores/uiStore';

/**
 * Applies the persisted `uiStore.textSize` to the document by setting a
 * `data-text-size` attribute on `<html>` (matching the
 * `html[data-text-size='…']` rules in `globals.css`, which scale the root
 * font size so rem-based text + labels respond). Mount once at the app root,
 * alongside `useThemeEffect`.
 */
export function useTextSizeEffect(): void {
  const textSize = useUIStore((s) => s.textSize);

  useEffect(() => {
    document.documentElement.setAttribute('data-text-size', textSize);
  }, [textSize]);
}
